<template>
  <v-card
    max-height="100%"
    class="caixa-veiculo"
    :hover="cxTemCapacidade() && cargaSelec.pode_editar"
    :disabled="!cxTemCapacidade()"
    :title="!cxTemCapacidade() ? 'Caixa não cadastrada para este veículo' : ''"
    @click="
      cxTemCapacidade() &&
      !produtoCaixa() &&
      cargaSelec.pode_editar &&
      !ver_detalhes
        ? clickCaixa()
        : null
    "
  >
    <v-card-title
      class="font-weight-bold pt-0 pb-0 grey lighten-3 justify-center fonte-cx cx-card-title"
    >
      Caixa {{ caixa.caixa }}
      <v-badge
        v-if="
          cxTemCapacidade() && produtoCaixa() && cargaSelec.carga_programada
        "
        icon="mdi-check"
        color="success"
        bordered
        offset-x="-5"
        offset-y="0"
      ></v-badge>

      <v-btn
        v-if="cxTemCapacidade() && cargaSelec.pode_editar && !ver_detalhes"
        fab
        class="btn-capac"
        color="info"
        title="Capacidades da caixa"
        :x-small="!isMobile()"
        :small="isMobile()"
        @click.stop="
          $router.push({ path: `${$route.path}/capacidade/${caixa.caixa}` })
        "
        ><v-icon>mdi-archive-search-outline</v-icon></v-btn
      >

      <btn-remover-produto-caixa-form-carga
        v-if="produtoCaixa() && cargaSelec.pode_editar && !ver_detalhes"
        :caixa="caixa"
      />
    </v-card-title>
    <v-card-text :style="{ height: '88%' }" class="caixa-conteudo">
      <v-layout v-if="!cxTemCapacidade()" fill-height justify-center column>
        <v-icon color="error">mdi-archive-remove-outline</v-icon>
        <p class="caption text-center red--text">Caixa Indisponível</p>
      </v-layout>
      <template v-else-if="produtoCaixa()">
        <div class="texto-item-caixa nro-ped-cx" v-if="!isMobile()">
          <p class="mb-0">Pedido:</p>
          <p class="mb-0 mt-1 body-1 font-weight-bold">{{produtoCaixa().pedido.nr_pedido}}</p>
        </div>
        <div class="conteudo-texto">
          <template v-if="isMobile()">
            <p class="texto-item-caixa mb-0 mt-1">
              Pedido:
              <span class="font-weight-bold subtitle-1">{{
                produtoCaixa().pedido.nr_pedido
              }}</span>
            </p>

            <v-divider class="mt-1 mb-2"></v-divider>
          </template>
          <p class="texto-item-caixa font-weight-bold mb-0" :class="{'mt-2': isMobile(), 'mt-3': !isMobile()}">
            {{ produtoCaixa().pedido.produto }}
          </p>

          <v-divider class="mt-2 mb-2"></v-divider>
          <p class="texto-item-caixa font-weight-bold mb-1 red--text" :style="{'font-family': 'Poppins !important'}">
            {{ produtoCaixa().pedido.nome_cliente }}
          </p>
          <p class="texto-item-caixa mb-0">
            {{ produtoCaixa().pedido.cidade_entrega }}
          </p>

          <v-chip
            color="teal"
            text-color="white"
            small
            class="mt-3 mb-2 font-weight-bold chip-container-mobile"
          >
            {{ produtoCaixa().qtde }} Kgs
          </v-chip>
        </div>

        <div class="chip-container">
          <v-chip
            small
            color="teal"
            class="texto-item-caixa-kg"
            text-color="white"
          >
            {{ produtoCaixa().qtde }} Kgs
          </v-chip>
        </div>
      </template>
      <v-layout v-else fill-height justify-center column>
        <v-icon color="success">mdi-archive-check-outline</v-icon>
        <p class="caption text-center green--text">Caixa disponível</p>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import BtnRemoverProdutoCaixaFormCarga from "./BtnRemoverProdutoCaixaFormCarga.vue";
export default {
  components: { BtnRemoverProdutoCaixaFormCarga },
  props: {
    caixa: { type: Object, required: true },
  },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("formacaoCarga", ["cargaSelec", "ver_detalhes"]),
  },
  methods: {
    ...mapMutations("formacaoCarga", ["setDialogPedLib"]),
    cxTemCapacidade() {
      return this.caixa.capacidade.length > 0;
    },
    produtoCaixa() {
      var pos = this.cargaSelec.dist_caixas.findIndex(
        (dc) => dc.caixa == this.caixa.caixa
      );
      if (pos < 0) return null;
      return this.cargaSelec.dist_caixas[pos];
    },
    isMobile() {
      return this.$mq == "sm";
    },
    clickCaixa() {
      this.$router.push({
        path: `/formacao-carga/${this.cargaSelec.id}/selecionar-pedido/${this.caixa.caixa}`,
      });
    },
  },
};
</script>

<style>
.caixa-veiculo {
  width: 13.3% !important;
  border: rgba(128, 128, 128, 0.6) solid 1px !important;
  /*overflow: hidden;
  word-wrap: break-word;
  white-space: normal;
  text-align: center;*/
}

.caixa-conteudo {
  flex-grow: 1; /* Permite que o conteúdo cresça */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Mantém a separação entre o texto e o chip */
  padding-left: 0.6vw;
  padding-right: 0.6vw;
  padding-bottom: 0.5vw;
}

.conteudo-texto {
  flex-grow: 1;
  overflow: hidden; /* Garante que o texto não empurre o chip */
  text-align: center;
}

.texto-item-caixa {
  font-family: "Roboto Condensed" !important;
  font-size: 0.69vw;
  line-height: 0.64vw;
}

.texto-item-caixa-kg span {
  font-family: "Roboto Condensed" !important;
  font-size: 0.72vw;
  font-weight: 600;
}

.chip-container .v-chip {
  height: 0.95vw !important;
}

.caixa-veiculo .fonte-cx {
  font-size: 0.8vw !important;
}

.chip-container {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}

.chip-container-mobile {
  display: none;
}

.cx-card-title {
  height: 12%;
}

@media screen and (max-width: 1654px) {
  .texto-item-caixa {
    font-size: 0.76vw !important;
    line-height: 0.75vw !important;
  }

  .chip-container .v-chip {
    height: 1.1vw !important;
  }

  .texto-item-caixa-kg span {
    font-size: 0.79vw;
  }
}

@media screen and (max-width: 947px) {
  .caixa-veiculo {
    width: 12.5% !important;
  }
}

@media screen and (max-width: 750px) {
  .caixa-veiculo {
    width: 100% !important;
    margin-top: 25px;
  }

  .caixa-conteudo {
    padding: 16px;
  }

  .caixa-veiculo .fonte-cx {
    font-size: 1rem !important;
  }

  .texto-item-caixa {
    font-family: "Poppins" !important;
    font-size: 0.9rem !important;
    line-height: 1.5rem !important;
  }

  .chip-container {
    display: none;
  }

  .chip-container-mobile {
    display: inline-block;
  }

  .cx-card-title {
    height: 30px;
  }
}
</style>